import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="debugger"
export default class extends Controller {
  toggle() {
    if (this.element.classList.contains("h-[50px]")) {
      this.element.classList.remove("h-[50px]");
      this.element.classList.add("h-[50%]");
    } else {
      this.element.classList.remove("h-[50%]");
      this.element.classList.add("h-[50px]");
    }
  }
}
